import React from "react";
import { ProjectType } from "../Projects";

type Props = {
  project: ProjectType;
  handleFlipped: (id: number) => void;
};
export const ProjectCard = ({ project, handleFlipped }: Props) => {
  return (
    <div
    onClick={() => handleFlipped(project.id)}
    className="md:w-[47%]  w-full relative flex justify-center inset-0 container-inner mb-12"
  >
    <div 
      className={`c w-full h-full rounded-lg image-shadow-lighter   back ${!project.isFlipped ? "flipped " : "not-flipped"}`}
    >
      <img
        alt="gallery"
        className="absolute  rounded-lg inset-0 w-full h-full object-cover object-top "
        src={require(`../../../${project.image}`)}
      />
    </div>
    <div
      className={`c front feedback-card  rounded-lg ${project.isFlipped ? "flipped " : "not-flipped"}`}
    >
      <h2 className="px-3 tracking-widest text-sm title-font font-medium text-green-400 mb-1">
        {project.subtitle}
      </h2>
      <h1 className="title-font text-lg font-medium text-white mb-3">
        {project.title}
      </h1>
      <p className=" leading-relaxed">{project.description}</p>
    </div>
  </div>
  );
};
